<template>
  <div>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.TRANSPORTER.value) && false"
      :link="{
            name: this.$t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'transporter.dashboard'}
          }"
    >
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.TRANSPORTER.value)"
      :material=true
      :link="{
            name: this.$t('sidebar.users'),
            icon: 'group',
          }"
    >
      <sidebar-item
        :link="{
            name: $t('sidebar.branches'),
            path: {name: 'transporter.subsidiary'},
            isRoute: false
          }"
      />
      <sidebar-item
        :link="{
            name: $t('sidebar.users'),
            path: {name: 'transporter.user'},
            isRoute: false
          }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.TRANSPORTER.value)"
      :link="{
            name: this.$t('sidebar.orders'),
            icon: 'tim-icons icon-delivery-fast',
          }"
    >
      <sidebar-item
        :link="{
            name: this.$t('sidebar.proposals'),
            path: {name: 'transporter.order_proposals'},
            isRoute: false,
          }"
      />
      <sidebar-item
        :link="{
            name: this.$t('pages.order.title.order'),
            path:{ name: 'transporter.order'},
            isRoute: false,
          }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.list_documents'),
          path: {name: 'transporter.orders_documents'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: $t('sidebar.import_cte'),
          path: {name: 'transporter.import_cte'},

          }"></sidebar-item>
      <sidebar-item
        :link="{
          name: $t('sidebar.not_imported_files'),
          path: {name: 'transporter.not_imported_files'},

          }"></sidebar-item>

      <sidebar-item
        :link="{
          name: $t('placeholders.exports'),
          path: {name: 'transporter.orders_exports'},
          isRoute: false,
        }"/>

    </sidebar-item>

    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.TRANSPORTER.value)"
      :link="{
            name: this.$t('sidebar.quotes'),
            icon: 'tim-icons icon-chart-bar-32',
          }"
    >
      <sidebar-item
        :link="{
            name: this.$t('sidebar.quotes_received'),
            path: {name: 'transporter.order_quotes_transporter'},
            isRoute: false,
          }"
      />

<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: this.$t('sidebar.quotes_transporter'),-->
<!--            path: {name: 'transporter.order_quotes'},-->
<!--            isRoute: false,-->
<!--          }"-->
<!--      />-->
    </sidebar-item>

    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.TRANSPORTER.value)"
      :link="{
            name: this.$t('sidebar.drivers'),
            icon: 'tim-icons icon-single-02',
            path: {name: 'transporter.driver'},
          }"
    >
    </sidebar-item>
<!--    <sidebar-item-->
<!--      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value, permission.INTEGRA_MANAGER__FINANCIER.value])-->
<!--           && $hasRole(role.TRANSPORTER.value)"-->
<!--      :link="{-->
<!--           name: $t('sidebar.orders_to_bill'),-->
<!--           icon: 'tim-icons icon-cart',-->
<!--           path: {name: 'transporter.purchase_order' }-->
<!--         }"-->
<!--    >-->
<!--    </sidebar-item>-->
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value, permission.INTEGRA_MANAGER__FINANCIER.value])
               && $hasRole(role.TRANSPORTER.value) && false"
      :material=true
      :link="{
              name: $t('sidebar.faturas'),
             icon: 'receipt',
             path: {name: 'transporter.bill'},
           }"
    >
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :material=true
      :link="{
              name: $t('sidebar.simulation'),
              icon: 'table',
            }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
                name: $t('sidebar.simulation_tables'),
                path: {name: 'transporter.simulation_integra.tables'}

              }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
                name: $t('sidebar.approve_table'),
                path: {name: 'transporter.simulation_integra.approve_table'}

              }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
          name: $t('sidebar.approve_route_table'),
          path: {name: 'transporter.approve_route_table'},
      }"/>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :material=true
      :link="{
              name: $t('sidebar.settings'),
              icon: 'settings',
              path: {name: 'transporter.configuration'}

            }"
    >
    </sidebar-item>

    <sidebar-item
      :link="{
        name: $t('sidebar.status_api'),
        icon: 'tim-icons icon-settings',
        path: {name: 'transporter.config_status_api'}
      }"
    >
    </sidebar-item>

    <!-- <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value, permission.INTEGRA_MANAGER__FINANCIER.value])
              && $hasRole(role.TRANSPORTER.value)"
      :link="{
              name: 'Integra Finance',
              icon: 'tim-icons icon-cart',
            }"
    >
      <sidebar-item
        :link="{
          name: 'Abra sua conta Daycoval',
          path: {name: 'transporter.profile'}
        }"
      >
      </sidebar-item>
      <sidebar-item
        :link="{
          name: 'Upload de Documentos',
          path: {name: 'transporter.profile'}
        }"
      >
      </sidebar-item>
      <sidebar-item
        :link="{
          name: 'Pedido de Antecipaçao',
          path: {name: 'transporter.loan_quote'}
        }"
      >
      </sidebar-item>
    </sidebar-item> -->

    <!--  VISUALIZADO POR TRANSPORTADORA QUE NAO FAZ PARTE DO INTEGRA  -->


  </div>
</template>

<script>
import userPermission from "@/util/valueObjects/userPermission";
import userRole from "@/util/valueObjects/userRole";

export default {
  name: "Sidebar",
  data() {
    return {
      role: userRole,
      permission: userPermission,
    }
  }
}
</script>

<style scoped>

</style>
